<template>
  <div class="bg-lineups">
    <div class="pb-0 mb-0 row blc-descracao blc-descracao-desktop">
      <div class="col-12 col-md-12">
        <div class="blc-tabela scroll">
          <div class="table-weather">
            <div class="d-flex align-items-center justify-content-between table-weather-responsive">
              <div class="title py-3">
                Waiting Time(days)
              </div>

              <div class="w-100 d-flex align-items-end justify-content-center tags">
                <div class="tag">
                  <span>BERTHED:</span>
                  {{ getVesselsCountByStatus(["Loading", "Discharging"]) }}
                </div>

                <div class="tag">
                  <span>WAITING AT ANCHORAGE:</span>
                  {{ getVesselsCountByStatus(["Waiting"]) }}
                </div>

                <div class="tag">
                  <span>EXPECTED TO CALL:</span>
                  {{ getVesselsCountByStatus(["Expected"]) }}
                </div>
              </div>

              <div class="d-flex align-items-center flex-shrink-0 gap">
                <div class="d-flex flex-column weather" v-for="weather in porto.weathers_atuais" :key="weather.id">
                  <div class="weather-date">
                    {{ weather.date | DDMMM }}
                  </div>

                    <div class="weather-icon">
                      <div
                        class="p-0"
                      >
                        <img :src="weather.icon" style="width: 50px" />
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-weather-body">
              <template v-for="(chunck, index) in chunckTerminais(porto.terminais)">
                <div v-for="terminal in chunck" :key="terminal.id">
                  <div class="waiting-time">
                    {{ terminal.name }}
                    <span class="number">{{ terminal.av_waiting_time }}</span>
                  </div>
                </div>
              </template>
          </div>
        </div>
      </div>
    </div>

    <div class="pb-0 form-row blc-descracao blc-descracao-desktop">      
      <div class="port">
        <span></span>

        <div class="port-name">
          <span>PORT OF</span>
          {{ porto.name }}
        </div>

        <div class="dropdown-lineups">
          <button
            v-if="hasPortFilter"
            class="button green"
            @click="$emit('exportPorts', porto.id)"
          >
            Export Port 
            <i class="fa-solid fa-file"></i>
          </button>
          <button @click="openPortTerminals" class="button">
            <i class="fa-solid fa-chevron-down " :class="{ 'rotate': showTerminals }"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- <div
      class="pb-0 form-row blc-descracao descracao_mobile"
      style="padding: 0 10px"
    >
      <div class="col-12">
        <h4 class="mt-1">{{ porto.name }}</h4>
        <button
          v-if="hasPortFilter"
          class="submit-verde"
          @click="$emit('exportPorts', porto.id)"
        >
          Export Port
        </button>
      </div>
      <div style="margin: auto; display: table">
        <div style="display: flex; padding: 0 5px">
          <div>
            <div class="result_top">BERTHED:</div>
            <p class="result">{{ getVesselsCountByStatus(["Loading", "Discharging"]) }}</p>
          </div>
          <div>
            <div class="result_top">WAITING:</div>
            <p class="result">{{ getVesselsCountByStatus(["Waiting"]) }}</p>
          </div>
          <div>
            <div class="result_top">EXPECTED:</div>
            <p class="result">{{ getVesselsCountByStatus(["Expected"]) }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="terminals-container">
      <div v-if="showTerminals" v-for="terminal in porto.terminais" :key="'table-' + terminal.id">
        <table_lineup
          v-bind="extraData"
          :terminal="terminal"
          :lineups="lineups.filter((l) => l.terminal_id == terminal.id)"
          @openModal="(l) => $emit('openModal', l)"
          @newLineup="(p) => $emit('newLineup', p)"
          @exportLineups="(id) => $emit('exportTerminal', id)"
          @sendProspect="(x) => $emit('sendProspect', x)"
          @refresh="fetchLineups(true)"
        />
        <h5
          v-if="terminal.remark"
          class="p-1 my-0 bg-warning"
          style="margin: 0 10px"
        >
          {{ terminal.remark }}
        </h5>
      </div>
    </div>

    <div v-if="nextCursor" class="text-center my-4">
      <button class="submit" @click="fetchLineups(false)" :disabled="loading">
        <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
        Load more for {{ porto.name }}
      </button>
    </div>
  </div>
</template>

<script>
import Service from "@/services/Lineups";
import TableLineup from "../Table.vue";
import Vue from "vue";

export default {
  components: { table_lineup: TableLineup },
  props: ["porto", "search", "extraData", "hasPortFilter"],
  data() {
    return { lineups: [], nextCursor: null, loading: false, showTerminals: true};
  },
  mounted() {
    this.fetchLineups(true);
  },
  methods: {
    fetchLineups(clear = false) {
      if (this.loading) return;
      this.loading = true;
      if (clear) {
        this.lineups = [];
        this.nextCursor = null;
      }

      Service.get({
        ...this.search,
        porto_id: [this.porto.id],
        cursor: this.nextCursor,
        limit: 300,
        with: [
          "carga",
          "cargaTipo",
          "terminal",
          "berco",
          "cargas",
          "afretadores",
          "cargas_afretadores.recebedor",
          "recebedor",
          "afretador",
          "agencia",
          "navio",
          "destination_port",
        ],
      })
        .then((res) => {
          const novos = res.data.data.map((i) => {
            Vue.set(i, "isInEdit", false);
            return i;
          });
          this.lineups = clear ? novos : [...this.lineups, ...novos];
          this.nextCursor = res.data.next_cursor;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVesselsCountByStatus(status = []) {
      return this.lineups.filter((l) => status.includes(l.status)).length;
    },
    chunckTerminais(t, s = 10) {
      const c = [];
      for (let i = 0; i < t.length; i += s) c.push(t.slice(i, i + s));
      return c;
    },
    
    openPortTerminals() {
      this.showTerminals = !this.showTerminals;

      console.log(this.showTerminals);
      if (this.showTerminals && !this.lineups.length) {
        this.fetchLineups(true);
      }
    }
  },
};
</script>]
<style>
@media(max-width: 992px) {
  .blc-descracao-desktop {
    display: flex !important;
  }
}
</style>